import React from "react";
import "./RaikoGridStylesheet.scss"

const RaikoGridOneColumn = (
    {
        children,
        className
    }) => {

    return (
        <div className={`gridOneColumnContainer ${className}`}>
            {children}
        </div>
    )
}

export default RaikoGridOneColumn